import { ConversationParticipantTypeEnumType, ConversationParticipantView } from '@mark43/cad-api';
import { ConversationKey } from './models';

export type FilterTabMenuType = 'DISPATCH_AREA' | 'INACTIVE';

export type ActiveFilterTabMenu = { tab?: FilterTabMenuType; isOpen: boolean };

export type ConversationsFilter =
    | { filterType: 'ALL_ACTIVE'; filterParticipant: null }
    | {
          filterType: ConversationParticipantTypeEnumType | 'INACTIVE';
          filterParticipant: ConversationParticipantView;
      };

export type ConversationItemData = {
    allOtherMembersLabel: string;
    allOtherMembersTooltip: string;
    conversationKey: ConversationKey;
    hasUrgentUnread?: boolean;
    lastMessageDateTimeDisplay: string;
    senderParticipantLabel: string;
    unreadCount?: number;
};

export type InsertConversationNudge = {
    createdDateUtc: string;
    id: number; // id is conversationId
    participantIds: number[];
    senderUserId: number;
    logT: 'INSERT';
};

export type InsertMessageNudge = {
    createdDateUtc: string;
    id: number; // id is conversationId
    isUrgent: boolean;
    messageId: number;
    senderUserId: number;
    messageUserIds: number[];
    logT: 'INSERT';
};

type LogT = 'INSERT' | 'UPDATE';

export type UpdateUserIdentityNudge = {
    createdDateUtc: string;
    id: number;
    user: number;
    logT: LogT;
};

export enum NudgeType {
    CONVERSATION = 'CONV',
    MESSAGE = 'MESS',
    DISPATCH_AREA_IDENTITY = 'DAOL',
    STATION_IDENTITY = 'CSUL',
    UNIT_IDENTITY = 'UUL',
}

export type ConversationKeyObject = {
    conversationId: number;
    participantIdentity?: ConversationParticipantView;
    isBookmarkedConversation: boolean;
};
